import React, { useState } from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { primaryColor, secondaryColor } from "../../../Constants/Colors";
import { useNavigate } from "react-router-dom";
import { useGetServicesQuery } from "../../../redux/api/ServicesApi/servicesApi";
import { useGetSettingsQuery } from "../../../redux/api/SettingsApi/settingsApi";
import LoaderSpinner from "../../../Components/LoaderSpinner";
import SEO from "../../../Components/SEO";

const Services = () => {
  const [hoverIndex, setHoverIndex] = useState(null);
  const navigate = useNavigate();
  const { data: settings } = useGetSettingsQuery();

  const { data, isLoading } = useGetServicesQuery({
    limit: 100, // Fetch all active services
    status: true,
    sortBy: "display_order",
    order: "asc",
  });

  const services = data?.services || [];

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <LoaderSpinner />
      </div>
    );
  }

  return (
    <div className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <SEO
        title="Our Services | Innovative Solutions by Ideal"
        description={settings?.meta_description}
        keywords={settings?.meta_keyword}
      />
      <Container>
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3" style={{ color: primaryColor }}>
            Our <span style={{ color: secondaryColor }}>Specialized</span>{" "}
            Services
          </h1>
          <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
            We provide a wide range of digital solutions to help your business
            grow and succeed in the modern digital landscape.
          </p>
        </div>

        <Row className="g-4">
          {services.map((service, index) => (
            <Col lg={6} key={service.id}>
              <Card
                className={`h-100 border-0 shadow-sm overflow-hidden service-card-dynamic`}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                onClick={() => navigate(`/services/${service.service_slug}`)}
                style={{
                  borderRadius: "20px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  transform: hoverIndex === index ? "translateY(-1px)" : "none",
                  boxShadow:
                    hoverIndex === index
                      ? "0 15px 30px rgba(0,0,0,0.1)"
                      : "0 5px 15px rgba(0,0,0,0.05)",
                }}
              >
                <Card.Body className="p-4 p-md-5">
                  <Row className="align-items-center h-100">
                    <Col xs={3} md={3} className="text-center">
                      {service.headerImage ? (
                        <Image
                          src={service.headerImage}
                          alt={service.service_title}
                          fluid
                          style={{ maxHeight: "80px", objectFit: "contain" }}
                        />
                      ) : (
                        <h2 className="fw-bold text-primary mb-0">
                          {index + 1}
                        </h2>
                      )}
                    </Col>
                    <Col xs={9} md={9}>
                      <h4
                        className="fw-bold mb-2"
                        style={{ color: primaryColor }}
                      >
                        {service.service_title}
                      </h4>
                      <p
                        className="text-muted mb-3"
                        style={{ fontSize: "15px" }}
                      >
                        {service.service_menu_description?.substring(0, 100)}...
                      </p>
                      <div
                        className="d-flex align-items-center gap-2 fw-bold"
                        style={{ color: secondaryColor, fontSize: "14px" }}
                      >
                        LEARN MORE <ArrowRight />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Services;
